(()=>{

const embed=document.getElementById('rdigital-bha-embed');
const root=document.getElementById('rdigital-bha-app');

if(!embed||!root)return;

const $=s=>root.querySelector(s);
const $$=s=>[...root.querySelectorAll(s)];
const moneyFmt=new Intl.NumberFormat('en-US',{
  style:'currency',
  currency:'USD',
  maximumFractionDigits:0
});

let state={
  step:0,
  data:{
    businessCategory:'',
    models:[],
    customerFocus:[],
    salesRegions:[],
    employeeRegions:[]
  },
  confirmed:{}
};

const why=[
  '',
  'Company identity, ownership status and business type help us interpret the assessment correctly and determine which external information may be relevant.',
  'Market positioning changes the economic and operating context of a business. These classifications are directional, so examples are provided to help identify the closest fit.',
  'Revenue channels, operating geography and agency reliance materially affect staffing, cost structure, technology requirements and operating complexity.',
  'Employee scale, management structure and employee geography help establish the organizational context required to interpret workforce productivity and operating complexity.',
  'Financial inputs establish the economic shape of the company and connect operating structure with revenue, margin, cost and investment levels.',
  'Completion measures how much applicable information was supplied. Assessment Confidence reflects the amount, consistency and quality of the evidence available and does not indicate whether the company is healthy.'
];

const moneyBands=[
  ['under_1m','Under $1M',500000],
  ['1_5m','$1M - $5M',3000000],
  ['5_10m','$5M - $10M',7500000],
  ['10_25m','$10M - $25M',17500000],
  ['25_50m','$25M - $50M',37500000],
  ['50_100m','$50M - $100M',75000000],
  ['100_250m','$100M - $250M',175000000],
  ['250_500m','$250M - $500M',375000000],
  ['500m_1b','$500M - $1B',750000000],
  ['1b_plus','$1B+',1500000000]
];

const ebitdaBands=[
  ['loss_100m_plus','Loss greater than $100M',-150000000],
  ['loss_50_100m','Loss $50M - $100M',-75000000],
  ['loss_25_50m','Loss $25M - $50M',-37500000],
  ['loss_10_25m','Loss $10M - $25M',-17500000],
  ['loss_5_10m','Loss $5M - $10M',-7500000],
  ['loss_1_5m','Loss $1M - $5M',-3000000],
  ['loss_under_1m','Loss under $1M',-500000],
  ['break_even','Approximately break-even',0],
  ['under_1m','Under $1M',500000],
  ['1_5m','$1M - $5M',3000000],
  ['5_10m','$5M - $10M',7500000],
  ['10_25m','$10M - $25M',17500000],
  ['25_50m','$25M - $50M',37500000],
  ['50_100m','$50M - $100M',75000000],
  ['100_250m','$100M - $250M',175000000],
  ['250_500m','$250M - $500M',375000000],
  ['500m_1b','$500M - $1B',750000000],
  ['1b_plus','$1B+',1500000000]
];

const marginBands=[
  ['1_10','1% - 10%',5.5],
  ['11_20','11% - 20%',15.5],
  ['21_30','21% - 30%',25.5],
  ['31_40','31% - 40%',35.5],
  ['41_50','41% - 50%',45.5],
  ['51_60','51% - 60%',55.5],
  ['61_70','61% - 70%',65.5],
  ['71_plus','71%+',75]
];

const growthBands=[
  ['down25','Down more than 25%',-35],
  ['down10_25','Down 10% - 25%',-17.5],
  ['flat_down10','Down 0% - 9%',-5],
  ['flat','Flat / roughly 0%',0],
  ['up1_10','Up 1% - 10%',5.5],
  ['up11_25','Up 11% - 25%',18],
  ['up26_50','Up 26% - 50%',38],
  ['up50','Up more than 50%',65]
];

const returnBands=[
  ['lt5','Under 5%',3],
  ['5_10','5% - 10%',7.5],
  ['11_20','11% - 20%',15.5],
  ['21_30','21% - 30%',25.5],
  ['31_40','31% - 40%',35.5],
  ['40_plus','Over 40%',45]
];

const weights={

  businessCategory:2,

  companyName:2,
  companyType:4,
  companyStatus:2,
  website:1,
  parentCompany:1,
  parentTicker:1,
  ticker:1,

  marketTier:4,
  customerFocus:2,

  models:5,
  primaryModel:4,
  salesRegions:3,
  agencyReliance:4,
  skuCountBand:3,

  employees:6,
  seniorLeadership:3,
  peopleManagers:3,
  employeeRegions:3,
  workArrangement:2,

  revenueBand:8,
  grossMarginBand:6,
  growthBand:4,
  opexBand:6,
  payrollBand:6,

  inventoryBand:5,
  techSpendBand:2,
  marketingSpendBand:2,
  reportedEbitdaBand:3,
  returnBand:3

};

const optionalLabels={

  website:'Primary Website',

  skuCountBand:'Active SKU Count',

  seniorLeadership:'Senior Leadership Team',
  peopleManagers:'People Managers',
  workArrangement:'Primary Work Arrangement',

  inventoryBand:'Current Inventory Value',
  techSpendBand:'Annual Technology Spend',
  marketingSpendBand:'Annual Marketing Spend',
  reportedEbitdaBand:'Reported EBITDA',
  returnBand:'Ecommerce / Marketplace Return Rate'

};

const businessRegions=[
  'North America',
  'LATAM',
  'EMEA',
  'APAC'
];

function regionPicker(
  id,
  title,
  help,
  definition,
  whyItMatters
){

  if(!Array.isArray(state.data[id])){
    state.data[id]=[];
  }

  const selected=state.data[id];
  const allSelected=
    businessRegions.every(
      region=>selected.includes(region)
    );

  return `
    <div class="secondaryQuestion regionQuestion">

      <div class="secondaryQuestionHeading">
        <span>${title}</span>
        ${tip(definition,whyItMatters)}
      </div>

      <div class="secondaryQuestionHelp">
        ${help}
      </div>

      <div class="choiceGrid regionGrid">

        <button
          type="button"
          class="choice ${allSelected?'selected':''}"
          data-region-group="${id}"
          data-region-value="Global"
        >
          Global
        </button>

        ${
          businessRegions.map(
            region=>`
              <button
                type="button"
                class="choice ${selected.includes(region)?'selected':''}"
                data-region-group="${id}"
                data-region-value="${region}"
              >
                ${region}
              </button>
            `
          ).join('')
        }

      </div>

    </div>
  `;

}

function moneyValue(k){

  const r=
    moneyBands.find(
      x=>x[0]===k
    );

  return r?r[2]:null;

}

function bandValue(list,k){

  const r=
    list.find(
      x=>x[0]===k
    );

  return r?r[2]:null;

}

function ebitdaOptions(){

  const revenue=
    moneyValue(
      state.data.revenueBand
    );

  const grossMargin=
    bandValue(
      marginBands,
      state.data.grossMarginBand
    );

  if(
    revenue===null ||
    grossMargin===null
  ){
    return ebitdaBands;
  }

  const impliedGrossProfit=
    revenue*(grossMargin/100);

  return ebitdaBands.filter(
    option=>{

      const midpoint=
        option[2];

      if(midpoint<=0){
        return true;
      }

      return midpoint<=impliedGrossProfit;

    }
  );

}

function digitalConsumer(){

  return (
    state.data.models.includes('Ecommerce') ||
    state.data.models.includes('Marketplaces')
  );

}

function physicalGoods(){

  return state.data.models.some(
    x=>[
      'Ecommerce',
      'Wholesale',
      'Retail Stores',
      'Marketplaces'
    ].includes(x)
  );

}

function applicable(){

  const k=[

    'businessCategory',

    'companyName',
    'companyType',
    'companyStatus',
    'website',

    'marketTier',
    'customerFocus',

    'models',
    'primaryModel',
    'salesRegions',
    'agencyReliance',
    'skuCountBand',

    'employees',
    'seniorLeadership',
    'peopleManagers',
    'employeeRegions',
    'workArrangement',

    'revenueBand',
    'grossMarginBand',
    'growthBand',
    'opexBand',
    'payrollBand',

    'techSpendBand',
    'marketingSpendBand',
    'reportedEbitdaBand'

  ];

  if(
    state.data.companyStatus==='Public'
  ){
    k.push('ticker');
  }

  if(
    state.data.companyStatus==='Subsidiary of Private Company' ||
    state.data.companyStatus==='Subsidiary of Public Company'
  ){
    k.push('parentCompany');
  }

  if(
    state.data.companyStatus==='Subsidiary of Public Company'
  ){
    k.push('parentTicker');
  }

  if(
    physicalGoods()
  ){
    k.push('inventoryBand');
  }

  if(
    digitalConsumer()
  ){
    k.push('returnBand');
  }

  return [
    ...new Set(k)
  ];

}

function answered(k){

  const v=
    state.data[k];

  return Array.isArray(v)
    ?v.length>0
    :v!==undefined &&
      v!==null &&
      String(v).trim()!=='';

}

function lowEvidenceAnswer(k){

  if(
    !answered(k)
  ){
    return true;
  }

  const v=
    String(
      state.data[k]||''
    ).toLowerCase();

  return (
    v==='unsure' ||
    v==='prefer not to say'
  );

}

function completionStats(){

  const all=
    applicable();

  return {
    total:all.length,
    answered:
      all.filter(answered).length
  };

}

function completion(){

  const s=
    completionStats();

  return s.total
    ?Math.round(
      (s.answered/s.total)*100
    )
    :0;

}

function weightedCoverage(){

  const keys=
    applicable();

  const possible=
    keys.reduce(
      (sum,k)=>
        sum+(weights[k]||1),
      0
    );

  const earned=
    keys.reduce(
      (sum,k)=>{

        const weight=
          weights[k]||1;

        if(
          !answered(k)
        ){
          return sum;
        }

        if(
          lowEvidenceAnswer(k)
        ){
          return sum+(weight*.35);
        }

        return sum+weight;

      },
      0
    );

  return possible
    ?(earned/possible)*100
    :0;

}

function frameworkCoverage(){

  const coverage=[

    answered('revenueBand') &&
    answered('grossMarginBand') &&
    answered('opexBand'),

    answered('seniorLeadership') ||
    answered('peopleManagers'),

    answered('employees') &&
    answered('opexBand'),

    answered('agencyReliance') ||
    answered('techSpendBand'),

    answered('employees') &&
    (
      answered('seniorLeadership') ||
      answered('peopleManagers') ||
      answered('workArrangement') ||
      answered('employeeRegions')
    )

  ];

  return (
    coverage.filter(Boolean).length /
    5 *
    100
  );

}

function consistencyScore(){

  const warnings=[

    ...checks(4).warnings,
    ...checks(5).warnings

  ];

  return Math.max(
    50,
    100-(warnings.length*10)
  );

}

function confidenceScore(){

  const coverage=
    weightedCoverage();

  const consistency=
    consistencyScore();

  const framework=
    frameworkCoverage();

  let score=
    Math.round(
      coverage*.65 +
      consistency*.20 +
      framework*.15
    );

  if(
    framework<60
  ){

    score=
      Math.min(
        score,
        69
      );

  }else if(
    framework<80
  ){

    score=
      Math.min(
        score,
        84
      );

  }

  return Math.max(
    0,
    Math.min(
      100,
      score
    )
  );

}

function confidence(){

  const s=
    confidenceScore();

  if(s>=85){
    return 'Very Strong';
  }

  if(s>=70){
    return 'Strong';
  }

  if(s>=55){
    return 'Moderate';
  }

  return 'Limited';

}

function updateProgress(){

  const c=
    completion();

  const completionValue=
    $('#completionValue');

  const completionBar=
    $('#completionBar');

  const progressText=
    $('#progressText');

  if(
    completionValue
  ){
    completionValue.textContent=
      c+'%';
  }

  if(
    completionBar
  ){
    completionBar.style.width=
      c+'%';
  }

  if(
    progressText
  ){

    progressText.textContent=

      c<35
        ?'Core profile started'

        :c<65
        ?'Core profile building'

        :c<85
        ?'Core profile complete - optional depth available'

        :'High information coverage';

  }

  $$('.step').forEach(
    (el,i)=>{

      el.classList.remove(
        'active',
        'done'
      );

      if(
        i<state.step
      ){
        el.classList.add(
          'done'
        );
      }
      else if(
        i===state.step
      ){
        el.classList.add(
          'active'
        );
      }

    }
  );

}

function tip(d,w){

  return `
    <span
      class="tip"
      tabindex="0"
    >
      i

      <span class="tipBox">

        <span class="tipSection">

          <span class="tipTitle">
            Definition
          </span>

          <span class="tipCopy">
            ${d}
          </span>

        </span>

        <span class="tipSection">

          <span class="tipTitle">
            Why It Matters
          </span>

          <span class="tipCopy">
            ${w}
          </span>

        </span>

      </span>

    </span>
  `;

}

function req(){

  return `
    <span class="req">
      Required
    </span>
  `;

}

function label(
  l,
  d,
  w,
  r
){

  return `
    <div class="fieldLabel">

      <span>
        ${l}
      </span>

      ${tip(d,w)}

      ${
        r
          ?req()
          :''
      }

    </div>
  `;

}

function sel(
  id,
  l,
  opts,
  d,
  w,
  r=false,
  h=''
){

  return `
    <div class="field">

      ${label(
        l,
        d,
        w,
        r
      )}

      <select
        data-id="${id}"
        ${
          r
            ?'data-required="1"'
            :''
        }
      >

        <option value="">
          Select...
        </option>

        ${
          opts.map(
            o=>`
              <option
                value="${o[0]}"
                ${
                  state.data[id]===o[0]
                    ?'selected'
                    :''
                }
              >
                ${o[1]}
              </option>
            `
          ).join('')
        }

      </select>

      ${
        h
          ?`
            <div class="helper">
              ${h}
            </div>
          `
          :''
      }

    </div>
  `;

}

function count(
  id,
  l,
  d,
  w,
  r=false
){

  return `
    <div class="field">

      ${label(
        l,
        d,
        w,
        r
      )}

      <input
        data-id="${id}"
        data-kind="count"
        ${
          r
            ?'data-required="1"'
            :''
        }
        type="text"
        inputmode="numeric"
        value="${state.data[id]??''}"
      >

      <div class="helper">
        Enter a whole number.
      </div>

    </div>
  `;

}

function normalizeWebsite(v){

  return String(v||'')
    .trim()
    .replace(
      /^https?:\/\//i,
      ''
    )
    .replace(
      /^www\./i,
      ''
    )
    .replace(
      /\/$/,
      ''
    );

}

function validWebsite(v){

  const host=
    normalizeWebsite(v)
      .split('/')[0];

  if(
    !host ||
    host.includes(' ') ||
    host.includes('..')
  ){
    return false;
  }

  const parts=
    host.split('.');

  if(
    parts.length<2
  ){
    return false;
  }

  const tld=
    parts.pop().toLowerCase();

  const name=
    parts.join('.');

  if(
    !/^[a-z0-9.-]+$/i.test(name) ||
    !/[a-z0-9]$/i.test(name)
  ){
    return false;
  }

  const common=[
    'com',
    'net',
    'org',
    'co',
    'io',
    'ai',
    'biz',
    'info',
    'shop',
    'store',
    'fashion',
    'app',
    'dev',
    'tech'
  ];

  return (
    /^[a-z]{2}$/i.test(tld) ||
    common.includes(tld)
  );

}

function overview(){

  return `
    <section class="introOnly">

      <div class="introHero">

        <div class="introTitle">

          <h1>
            Business Health Assessment
          </h1>

          <p>
            A structured self-service diagnostic designed to help leadership better understand how the business is operating, identify potential gaps, and determine where a deeper review may create value. This assessment uses RDigital's Operator Health Framework as a directional lens to surface signals across five key areas of the business.
          </p>

        </div>

      </div>

      <div class="introBody">

        <div class="introFeature">

          <h2>
            RDigital Operator Health Framework
          </h2>

          <div class="introAreas">

            <div class="introArea">

              <div class="introAreaHeading">

                <div class="introAreaNum">
                  1.
                </div>

                <div class="introAreaTitle">
                  Financial Visibility
                </div>

              </div>

              <div class="introAreaCopy">
                Understand how clearly leadership can see revenue, margin, major costs, inventory, and financial commitments across the business.
              </div>

            </div>


            <div class="introArea">

              <div class="introAreaHeading">

                <div class="introAreaNum">
                  2.
                </div>

                <div class="introAreaTitle">
                  Ownership & Accountability
                </div>

              </div>

              <div class="introAreaCopy">
                Evaluate whether critical outcomes have clear owners with the authority, information, and resources required to deliver them.
              </div>

            </div>


            <div class="introArea">

              <div class="introAreaHeading">

                <div class="introAreaNum">
                  3.
                </div>

                <div class="introAreaTitle">
                  Operating Efficiency
                </div>

              </div>

              <div class="introAreaCopy">
                Review whether headcount, management structure, processes, and resources are appropriate for the company's current scale and complexity.
              </div>

            </div>


            <div class="introArea">

              <div class="introAreaHeading">

                <div class="introAreaNum">
                  4.
                </div>

                <div class="introAreaTitle">
                  Technology & Partners
                </div>

              </div>

              <div class="introAreaCopy">
                Identify how technology, agencies, vendors, and outside partners support the business, including potential overlap or unnecessary cost.
              </div>

            </div>


            <div class="introArea">

              <div class="introAreaHeading">

                <div class="introAreaNum">
                  5.
                </div>

                <div class="introAreaTitle">
                  People & Culture
                </div>

              </div>

              <div class="introAreaCopy">
                Consider workforce structure, management context, organizational complexity, and where deeper people-related review may be warranted.
              </div>

            </div>

          </div>

        </div>


        <div class="introAction">

          <div class="introCategoryCard">

            <h3>
              Start Assessment
            </h3>

            <p class="introActionCopy">
              Choose the industry profile that best matches the business being assessed.
            </p>

            <div class="field">

              <select
                id="businessCategorySelect"
                data-id="businessCategory"
                required
                aria-label="Business category"
              >

                <option value="">
                  Select a category...
                </option>

                <option
                  value="Fashion"
                  ${
                    state.data.businessCategory==='Fashion'
                      ?'selected'
                      :''
                  }
                >
                  Fashion
                </option>

              </select>

              <div class="introComingSoon">
                Beta currently supports a single operating Fashion brand or business with direct responsibility for its revenue, costs, employees and operations. Portfolio and holding-company assessments will be supported separately.
              </div>

            </div>

            <button
              type="button"
              class="btn primary introStart introInactive"
              id="introStart"
              aria-disabled="true"
            >
              Start Assessment
            </button>

          </div>

        </div>

      </div>

    </section>
  `;

}

function category(){

  const companyTypeOptions=[

    [
      'Brand / Manufacturer',
      'Brand / Manufacturer'
    ],

    [
      'Multi-Brand Retailer',
      'Multi-Brand Retailer'
    ],

    [
      'Wholesale',
      'Wholesale'
    ],

    [
      'Marketplace',
      'Marketplace'
    ],

    [
      'Licensing',
      'Licensing'
    ],

    [
      'Mixed / Multi-Business Company',
      'Mixed / Multi-Business Company'
    ]

  ];

  const companyStatusOptions=[

    [
      'Private',
      'Private'
    ],

    [
      'Public',
      'Public'
    ],

    [
      'Subsidiary of Private Company',
      'Subsidiary of Private Company'
    ],

    [
      'Subsidiary of Public Company',
      'Subsidiary of Public Company'
    ]

  ];

  const isPublic=
    state.data.companyStatus==='Public';

  const isPrivateSubsidiary=
    state.data.companyStatus==='Subsidiary of Private Company';

  const isPublicSubsidiary=
    state.data.companyStatus==='Subsidiary of Public Company';

  const isSubsidiary=
    isPrivateSubsidiary ||
    isPublicSubsidiary;

  return `
    <section class="companyProfileScreen">

      <div class="sectionHead">

        <h2>
          Company Profile
        </h2>

        <p>
          Provide the core information about the operating brand or business being assessed.
        </p>

      </div>

      <div class="formGrid">

        <div class="field">

          ${label(
            'Brand Name',
            'The primary operating brand or business being assessed.',
            'The name helps identify the correct organization and supports future external-data enrichment.',
            true
          )}

          <input
            data-id="companyName"
            data-required="1"
            type="text"
            autocomplete="organization"
            placeholder="Example: Reebok"
            value="${state.data.companyName??''}"
          >

        </div>

        ${sel(
          'companyStatus',
          'Company Status',
          companyStatusOptions,
          'The ownership or reporting status of the operating business.',
          'Public, private and subsidiary businesses may have different reporting structures and different levels of available external information.',
          true
        )}

        ${
          isPublic
            ?`
              <div class="field">

                ${label(
                  'Ticker Symbol',
                  'The public-market ticker associated with the company.',
                  'A confirmed ticker can support matching to public filings and financial information.',
                  false
                )}

                <input
                  data-id="ticker"
                  type="text"
                  autocomplete="off"
                  placeholder="Example: NKE"
                  value="${state.data.ticker??''}"
                >

              </div>
            `
            :isSubsidiary
            ?`
              <div class="field">

                ${label(
                  'Parent Company',
                  'The company or organization that owns or controls the operating business being assessed.',
                  'Parent-company information helps distinguish the operating business from the broader corporate organization.',
                  true
                )}

                <input
                  data-id="parentCompany"
                  data-required="1"
                  type="text"
                  autocomplete="organization"
                  placeholder="Example: Authentic Brands Group"
                  value="${state.data.parentCompany??''}"
                >

              </div>
            `
            :`
              <div></div>
            `
        }

        ${sel(
          'companyType',
          'Company Type',
          companyTypeOptions,
          'The primary way the operating business participates in the market.',
          'Company type helps establish the context used to interpret channels, staffing, economics and operating complexity.',
          true
        )}

        <div class="field">

          ${label(
            'Primary Website',
            'The primary public website associated with the operating business or brand.',
            'The website helps identify the correct organization and can support external-data enrichment.',
            false
          )}

          <input
            data-id="website"
            type="text"
            inputmode="url"
            autocomplete="url"
            placeholder="Example: reebok.com"
            value="${state.data.website??''}"
          >

          <div class="helper">
            Enter the primary public website.
          </div>

        </div>

        ${
          isPublicSubsidiary
            ?`
              <div class="field">

                ${label(
                  'Parent Company Ticker',
                  'The public-market ticker associated with the parent company.',
                  'A confirmed parent ticker can support matching to public filings and ownership information.',
                  false
                )}

                <input
                  data-id="parentTicker"
                  type="text"
                  autocomplete="off"
                  placeholder="Example: WHP"
                  value="${state.data.parentTicker??''}"
                >

              </div>
            `
            :''
        }

      </div>

    </section>
  `;

}

function positioning(){

  const tiers=[

    [

      'Luxury',

      'Prestige positioning with very high price points, selective distribution and strong brand equity. Examples include Hermès, Louis Vuitton and Gucci.',

      'Luxury businesses typically operate with different pricing power, margin expectations, distribution strategies and customer-acquisition economics.'

    ],

    [

      'Premium',

      'Above-mainstream positioning with higher perceived quality, brand value or specialization. Examples include Ralph Lauren, Coach and Lululemon.',

      'Premium businesses often support higher price points and margins than mass-market businesses but may require greater brand, product and customer-experience investment.'

    ],

    [

      'Mass / Value',

      'Broad-access positioning focused on affordability, scale and frequent consumer demand. Examples include Old Navy, H&M and Uniqlo.',

      'Mass and value businesses generally depend heavily on scale, inventory productivity, cost control and efficient distribution.'

    ],

    [

      'Mixed / Multi-Tier',

      'The business operates across materially different price or market-positioning tiers.',

      'A mixed positioning can increase assortment, pricing, channel and customer complexity and may require different operating assumptions across parts of the business.'

    ]

  ];


  const customers=[
    'Women',
    'Men',
    'Kids'
  ];


  if(
    !Array.isArray(
      state.data.customerFocus
    )
  ){

    state.data.customerFocus=[];

  }


  const allSelected=
    customers.every(
      x=>
        state.data.customerFocus.includes(x)
    );


  return `
    <section class="positioningScreen">

      <div class="sectionHead">

        <h2>
          Market Positioning
        </h2>

        <p>
          Define where the business sits in the market and which customer groups it serves.
        </p>

      </div>


      <div class="subQuestionHeading">

        <span>
          Primary Market Positioning
        </span>

        ${req()}

      </div>


      <div class="choiceGrid positioningGrid">

        ${
          tiers.map(
            (
              [
                name,
                definition,
                whyItMatters
              ]
            )=>`

              <button
                type="button"
                class="
                  choice
                  ${
                    state.data.marketTier===name
                      ?'selected'
                      :''
                  }
                "
                data-tier="${name}"
              >

                <span class="choiceRow">

                  <span>
                    ${name}
                  </span>

                  ${tip(
                    definition,
                    whyItMatters
                  )}

                </span>

              </button>

            `
          ).join('')
        }

      </div>


      <div class="subQuestionHeading customerFocusHeading">

        <span>
          Customer Focus
        </span>

        ${req()}

      </div>


      <label class="selectAllRow">

        <input
          type="checkbox"
          id="selectAllCustomers"
          ${
            allSelected
              ?'checked'
              :''
          }
        >

        <span>
          Select All
        </span>

      </label>


      <div class="choiceGrid customerGrid">

        ${
          customers.map(
            x=>`

              <button
                type="button"
                class="
                  choice
                  ${
                    state.data.customerFocus.includes(x)
                      ?'selected'
                      :''
                  }
                "
                data-customer="${x}"
              >
                ${x}
              </button>

            `
          ).join('')
        }

      </div>

    </section>
  `;

}

function model(){

  const channels=[

    [
      'Ecommerce',
      'Selling products through a company-operated ecommerce website or digital storefront.',
      'Ecommerce introduces customer acquisition, conversion, technology, fulfillment and return considerations.'
    ],

    [
      'Wholesale',
      'Selling products to retailers, distributors or other businesses for resale.',
      'Wholesale has different margin, inventory, sales and operating requirements than direct consumer channels.'
    ],

    [
      'Retail Stores',
      'Selling products through company-operated physical retail locations.',
      'Retail stores introduce labor, occupancy, inventory allocation and location-level operating complexity.'
    ],

    [
      'Marketplaces',
      'Selling products through third-party marketplaces such as Amazon, Walmart Marketplace or similar platforms.',
      'Marketplaces can introduce additional fees, advertising costs, fulfillment requirements and channel dependencies.'
    ],

    [
      'Licensing',
      'Generating revenue by licensing brands, trademarks, intellectual property or product rights to third parties.',
      'Licensing can operate with a very different staffing, cost and capital structure than owned-product businesses.'
    ],

    [
      'Other',
      'A meaningful revenue channel that is not represented by the options above.',
      'Some businesses use specialized revenue models that require additional context.'
    ]

  ];

  const agencyOptions=[
    ['None','None'],
    ['Low','Low'],
    ['Medium','Medium'],
    ['High','High'],
    ['Unsure','Unsure']
  ];

  const skuOptions=[
    ['under_100','Under 100'],
    ['100_499','100 - 499'],
    ['500_999','500 - 999'],
    ['1000_4999','1,000 - 4,999'],
    ['5000_9999','5,000 - 9,999'],
    ['10000_plus','10,000+'],
    ['Unsure','Unsure']
  ];

  return `
    <section class="modelScreen">

      <div class="sectionHead">

        <h2>
          Operating Model
        </h2>

        <p>
          Describe how the business generates revenue, its operating complexity, and its geographic reach.
        </p>

      </div>

      <div class="choiceGrid modelChoiceGrid">

        ${
          channels.map(
            (
              [
                name,
                definition,
                whyItMatters
              ]
            )=>`

              <button
                type="button"
                class="choice ${state.data.models.includes(name)?'selected':''}"
                data-model="${name}"
              >

                <span class="choiceRow">
                  <span>${name}</span>
                  ${tip(definition,whyItMatters)}
                </span>

              </button>

            `
          ).join('')
        }

      </div>

      <div class="secondaryQuestionGrid operatingSecondaryGrid">

        <div class="secondaryQuestion">

          <div class="secondaryQuestionHeading">
            <span>Primary Revenue Channel</span>
            ${req()}
          </div>

          <div class="secondaryQuestionHelp">
            Select the channel that generates the largest share of company revenue.
          </div>

          <select
            data-id="primaryModel"
            data-required="1"
          >

            <option value="">Select...</option>

            ${
              state.data.models.map(
                x=>`
                  <option
                    value="${x}"
                    ${state.data.primaryModel===x?'selected':''}
                  >
                    ${x}
                  </option>
                `
              ).join('')
            }

          </select>

        </div>

        <div class="secondaryQuestion">

          <div class="secondaryQuestionHeading">
            <span>Agency / Consultant Reliance</span>
            ${tip(
              'How much the company depends on outside agencies or consultants to perform ongoing work.',
              'Agency reliance can affect internal headcount, cost structure and operating capacity.'
            )}
            ${req()}
          </div>

          <div class="secondaryQuestionHelp">
            Consider recurring outside support across the business rather than one-time projects.
          </div>

          <select
            data-id="agencyReliance"
            data-required="1"
          >

            <option value="">Select...</option>

            ${
              agencyOptions.map(
                o=>`
                  <option
                    value="${o[0]}"
                    ${state.data.agencyReliance===o[0]?'selected':''}
                  >
                    ${o[1]}
                  </option>
                `
              ).join('')
            }

          </select>

        </div>

        <div class="secondaryQuestion">

          <div class="secondaryQuestionHeading">
            <span>Active SKU Count</span>
            ${tip(
              'The approximate number of unique sellable product variations currently active. A SKU typically represents a specific product, color and size combination.',
              'SKU count is a useful indicator of assortment and inventory complexity. Higher SKU counts can increase planning, merchandising, inventory, technology and fulfillment requirements.'
            )}
          </div>

          <div class="secondaryQuestionHelp">
            Estimate the number of active sellable SKUs across the business.
          </div>

          <select data-id="skuCountBand">

            <option value="">Select...</option>

            ${
              skuOptions.map(
                o=>`
                  <option
                    value="${o[0]}"
                    ${state.data.skuCountBand===o[0]?'selected':''}
                  >
                    ${o[1]}
                  </option>
                `
              ).join('')
            }

          </select>

        </div>

      </div>

      ${regionPicker(
        'salesRegions',
        'Regions Sold Into',
        'Select every region where the business currently generates meaningful commercial revenue.',
        'The regions where the business currently generates meaningful commercial revenue.',
        'Commercial geography affects market complexity, compliance, logistics, localization, tax considerations and operating requirements.'
      )}

    </section>
  `;

}

function people(){

  const workOptions=[

    [
      'In Office',
      'In Office'
    ],

    [
      'Hybrid',
      'Hybrid'
    ],

    [
      'Remote',
      'Remote'
    ],

    [
      'Mixed / Varies',
      'Mixed / Varies'
    ]

  ];

  return `
    <section class="peopleScreen">

      <div class="sectionHead">

        <h2>
          People & Ops
        </h2>

        <p>
          Provide the workforce structure and employee footprint used to understand organizational scale and complexity.
        </p>

      </div>

      <div class="formGrid">

        ${count(
          'employees',
          'Total Employees',
          'Approximate number of full-time and part-time employees. Do not include outside agencies or consultants.',
          'Employee count is a core denominator for workforce productivity and organizational-density measures.',
          true
        )}

        ${count(
          'seniorLeadership',
          'Senior Leadership Team',
          'People with meaningful company-wide, business-unit or functional decision authority regardless of title.',
          'Leadership-team size can help identify organizational density without assuming every company uses the same title structure.',
          false
        )}

        ${count(
          'peopleManagers',
          'People Managers',
          'Employees with formal responsibility for managing one or more employees.',
          'The number of people managers provides a directional view of management layering and spans of control.',
          false
        )}

        ${sel(
          'workArrangement',
          'Primary Work Arrangement',
          workOptions,
          'The primary way employees work across the organization.',
          'Work arrangement provides context for management structure, office costs, collaboration patterns and geographic complexity.',
          false
        )}

      </div>

      ${regionPicker(
        'employeeRegions',
        'Employee Locations',
        'Select every region where company employees are based.',
        'The regions where company employees are based.',
        'Employee geography affects management complexity, employment requirements, payroll administration, communication and operating structure.'
      )}

    </section>
  `;

}

function economics(){

  return `
    <section class="economicsScreen">

      <div class="sectionHead">

        <h2>
          Economics
        </h2>

        <p>
          Use directional ranges to describe growth, profitability, cost structure, and other key operating metrics.
        </p>

      </div>

      <div class="formGrid economicsGrid">

        ${sel(
          'revenueBand',
          'Annual Revenue',
          moneyBands,
          'Trailing 12-month gross revenue before expenses.',
          'Revenue anchors nearly every scale, productivity and cost relationship in the diagnostic.',
          true
        )}

        ${sel(
          'opexBand',
          'Annual Operating Expenses',
          moneyBands,
          'Approximate annual operating expenses below gross profit. Do not include COGS again.',
          'Operating expenses help show how much of gross profit is consumed by the cost structure required to run the business.',
          true
        )}

        ${sel(
          'payrollBand',
          'Annual Payroll',
          moneyBands,
          'Approximate annual salary, wages and bonus expense.',
          'Payroll relative to revenue and employee count helps identify labor intensity and workforce productivity.',
          true
        )}

        ${sel(
          'grossMarginBand',
          'Gross Margin',
          marginBands,
          'Gross profit as a percentage of revenue.',
          'Gross margin helps distinguish healthy revenue from revenue carrying too little product-level profit.',
          true
        )}

        ${sel(
          'growthBand',
          'Revenue Growth - Last 12 Months',
          growthBands,
          'Year-over-year revenue growth for the latest 12-month period.',
          'Growth context changes how we interpret spend, staffing and operating leverage.',
          true
        )}

        ${sel(
          'reportedEbitdaBand',
          'Reported EBITDA',
          ebitdaOptions(),
          'Reported EBITDA from management accounts or financial statements for the same 12-month period used above.',
          'Reported EBITDA provides a direct profitability reference for the assessment.',
          true
        )}

      </div>

      <div class="economicsOptional">

        <h3>
          Optional Metrics
        </h3>

        <div class="formGrid economicsGrid">

          ${sel(
            'techSpendBand',
            'Annual Technology Spend',
            moneyBands,
            'Approximate annual spend on software, SaaS, ecommerce platforms, infrastructure and external technology services.',
            'Technology intensity can help identify underinvestment, duplication or an overly expensive technology environment.',
            false
          )}

          ${sel(
            'marketingSpendBand',
            'Annual Marketing Spend',
            moneyBands,
            'Approximate annual marketing spend, including paid media and related marketing investment.',
            'Marketing intensity helps contextualize growth efficiency and customer-acquisition dependence.',
            false
          )}

          ${
            physicalGoods()
              ?sel(
                'inventoryBand',
                'Current Inventory Value',
                moneyBands,
                'Approximate current inventory value.',
                'Inventory relative to revenue can reveal trapped cash, aging stock and markdown exposure.',
                false
              )
              :''
          }

          ${
            digitalConsumer()
              ?sel(
                'returnBand',
                'Ecommerce / Marketplace Return Rate',
                returnBands,
                'Approximate return rate for consumer digital orders only.',
                'Digital return behavior can materially affect margin, logistics cost, inventory quality and customer-acquisition economics.',
                false
              )
              :''
          }

        </div>

      </div>

    </section>
  `;

}

function normalizeCounts(){

  $$(
    '[data-kind="count"]'
  ).forEach(
    el=>{

      const n=
        parseInt(
          String(
            el.value||''
          ).replace(
            /,/g,
            ''
          ),
          10
        );

      if(
        Number.isFinite(n)
      ){

        state.data[
          el.dataset.id
        ]=
          String(
            Math.max(
              0,
              n
            )
          );

        el.value=
          String(
            Math.max(
              0,
              n
            )
          );

      }

    }
  );

}

function checks(
  step=state.step
){

  const er=[];
  const wa=[];

  if(
    step===1
  ){

    if(
      answered('website') &&
      !validWebsite(
        state.data.website
      )
    ){

      er.push(
        'Enter a valid Primary Website, such as example.com.'
      );

    }

    if(
      state.data.companyStatus==='Public' &&
      answered('ticker') &&
      !/^[A-Za-z]{1,5}([.-][A-Za-z]{1,2})?$/.test(
        String(
          state.data.ticker
        ).trim()
      )
    ){

      er.push(
        'Enter a valid ticker-symbol format, such as NKE or BRK.B.'
      );

    }

    if(
      state.data.companyStatus==='Subsidiary of Public Company' &&
      answered('parentTicker') &&
      !/^[A-Za-z]{1,5}([.-][A-Za-z]{1,2})?$/.test(
        String(
          state.data.parentTicker
        ).trim()
      )
    ){

      er.push(
        'Enter a valid parent-company ticker-symbol format, such as NKE or BRK.B.'
      );

    }

  }

  if(
    step===4
  ){

    const emp=
      parseInt(
        state.data.employees||0,
        10
      )||0;

    const leadership=
      parseInt(
        state.data.seniorLeadership||0,
        10
      )||0;

    const managers=
      parseInt(
        state.data.peopleManagers||0,
        10
      )||0;

    if(
      emp<=0
    ){

      er.push(
        'Total Employees must be greater than zero.'
      );

    }

    if(
      leadership>emp
    ){

      er.push(
        'Senior Leadership Team cannot exceed Total Employees.'
      );

    }

    if(
      managers>emp
    ){

      er.push(
        'People Managers cannot exceed Total Employees.'
      );

    }

  }

  if(
    step===5
  ){

    const rev=
      moneyValue(
        state.data.revenueBand
      );

    const op=
      moneyValue(
        state.data.opexBand
      );

    const pay=
      moneyValue(
        state.data.payrollBand
      );

    const inv=
      moneyValue(
        state.data.inventoryBand
      );

    if(
      rev &&
      pay &&
      pay>rev
    ){

      wa.push(
        'Payroll is in a higher range than Annual Revenue. Please confirm the ranges use the same 12-month period.'
      );

    }

    if(
      rev &&
      op &&
      op>rev*1.5
    ){

      wa.push(
        'Operating Expenses appear unusually high relative to Revenue. Please confirm the ranges and time period.'
      );

    }

    if(
      inv &&
      rev &&
      inv>rev
    ){

      wa.push(
        'Current Inventory Value is in a higher range than Annual Revenue. This may be valid for a seasonal or inventory-heavy business, but should be confirmed.'
      );

    }

  }

  return {
    errors:er,
    warnings:wa
  };

}

function requiredMissing(){

  if(
    state.step===0
  ){

    return !answered(
      'businessCategory'
    );

  }


  if(
    state.step===1
  ){

    const subsidiary=
      state.data.companyStatus==='Subsidiary of Private Company' ||
      state.data.companyStatus==='Subsidiary of Public Company';

    return (
      !answered('companyName') ||
      !answered('companyType') ||
      !answered('companyStatus') ||
      (
        subsidiary &&
        !answered('parentCompany')
      )
    );

  }


  if(
    state.step===2
  ){

    return (
      !answered('marketTier') ||
      !(state.data.customerFocus||[]).length
    );

  }


  if(
    state.step===3
  ){

    return (
      !(state.data.models||[]).length ||
      !answered('primaryModel') ||
      !answered('agencyReliance')
    );

  }


  return $$(
    '[data-required="1"]'
  ).some(
    el=>
      !String(
        el.value||''
      ).trim()
  );

}

const metricTips={

  'Revenue / Employee':[

    'Approximate annual revenue divided by total employees using the midpoint of the selected revenue range.',

    'Provides a directional view of workforce productivity and operating leverage.'

  ],

  'Payroll / Revenue':[

    'Approximate annual payroll as a percentage of annual revenue using the selected range midpoints.',

    'Shows how much revenue is being consumed by employee compensation.'

  ],

  'OpEx / Revenue':[

    'Approximate annual operating expenses as a percentage of annual revenue using the selected range midpoints.',

    'Shows the weight of the operating cost structure relative to revenue.'

  ],

  'Inventory / Revenue':[

    'Current inventory value as a percentage of annual revenue using the selected range midpoints.',

    'Helps identify potential working-capital pressure, aging inventory and markdown exposure.'

  ]

};

function metric(
  t,
  v,
  c,
  s,
  r
){

  const info=
    metricTips[t]||[
      '',
      ''
    ];

  return `
    <article class="metric ${c}">

      <div class="metricTitleRow">

        <div class="metricTitle">
          ${t}
        </div>

        ${tip(
          info[0],
          info[1]
        )}

      </div>

      <div class="metricValue ${c}">
        ${v}
      </div>

      <div class="status ${c}">
        ${s}
      </div>

      <div class="metricWhy">
        ${r}
      </div>

    </article>
  `;

}

function lensCard(
  title,
  status,
  color,
  summary,
  recommendation
){

  return `
    <article class="lensCard ${color}">

      <div class="lensHead">

        <div class="lensTitle">
          ${title}
        </div>

        <div class="lensStatus ${color}">
          ${status}
        </div>

      </div>

      <p>
        ${summary}
      </p>

      <div class="lensRec">

        <strong>
          Suggested next step:
        </strong>

        ${recommendation}

      </div>

    </article>
  `;

}

function recommendationCard(
  n,
  title,
  copy
){

  return `
    <article class="recCard">

      <div class="recNum">
        Priority ${n}
      </div>

      <h4>
        ${title}
      </h4>

      <p>
        ${copy}
      </p>

    </article>
  `;

}

function results(){

  const rev=moneyValue(state.data.revenueBand)||0;
  const pay=moneyValue(state.data.payrollBand)||0;
  const op=moneyValue(state.data.opexBand)||0;
  const emp=parseInt(state.data.employees||1,10)||1;
  const inv=moneyValue(state.data.inventoryBand);
  const tech=moneyValue(state.data.techSpendBand);
  const leaders=parseInt(state.data.seniorLeadership||0,10)||0;
  const managers=parseInt(state.data.peopleManagers||0,10)||0;

  const grossMargin=bandValue(marginBands,state.data.grossMarginBand);
  const growth=bandValue(growthBands,state.data.growthBand);
  const ebitda=bandValue(ebitdaBands,state.data.reportedEbitdaBand);

  const rpe=rev?rev/emp:0;
  const pp=rev?pay/rev*100:null;
  const oo=rev?op/rev*100:null;
  const ir=inv!==null&&rev?inv/rev*100:null;
  const techPct=tech!==null&&rev?tech/rev*100:null;

  const cs=completionStats();
  const completionPct=completion();
  const confidenceLabel=confidence();

  const completionColor=
    completionPct>=90?'green':
    completionPct>=70?'amber':
    'red';

  const confidenceColor=
    confidenceLabel==='Very Strong'||confidenceLabel==='Strong'?'green':
    confidenceLabel==='Moderate'?'amber':
    'red';

  const payrollColor=
    pp===null?'amber':
    pp<=35?'green':
    pp<=50?'amber':
    'red';

  const payrollStatus=
    pp===null?'More Data Needed':
    pp<=35?'Healthy Range':
    pp<=50?'Watch':
    'Priority';

  const opexColor=
    oo===null?'amber':
    oo<=80?'green':
    oo<=100?'amber':
    'red';

  const opexStatus=
    oo===null?'More Data Needed':
    oo<=80?'Healthy Range':
    oo<=100?'Watch':
    'Priority';

  const inventoryColor=
    ir===null?'amber':
    ir<=20?'green':
    ir<=35?'amber':
    'red';

  const inventoryStatus=
    ir===null?'More Data Needed':
    ir<=20?'Healthy Range':
    ir<=35?'Watch':
    'Priority';

  const rpeColor='amber';
  const rpeStatus='Peer Benchmark Needed';

  let finColor='green';
  let finStatus='Healthy Signal';
  if(
    ebitda===null ||
    grossMargin===null ||
    growth===null ||
    pp===null ||
    oo===null
  ){
    finColor='amber';
    finStatus='More Data Needed';
  }else if(
    ebitda<0 ||
    growth<=-10 ||
    oo>100
  ){
    finColor='red';
    finStatus='Priority';
  }else if(
    ebitda===0 ||
    growth<=0 ||
    grossMargin<31 ||
    pp>35 ||
    oo>80
  ){
    finColor='amber';
    finStatus='Watch';
  }

  const managerPct=emp?managers/emp*100:null;
  const leaderPct=emp?leaders/emp*100:null;

  let ownershipColor='green';
  let ownershipStatus='Healthy Signal';
  if(!answered('seniorLeadership')||!answered('peopleManagers')){
    ownershipColor='amber';
    ownershipStatus='More Data Needed';
  }else if(managerPct>35){
    ownershipColor='red';
    ownershipStatus='Priority';
  }else if(managerPct>25||leaderPct>20){
    ownershipColor='amber';
    ownershipStatus='Watch';
  }

  let efficiencyColor='green';
  let efficiencyStatus='Healthy Signal';
  if(pp===null||oo===null){
    efficiencyColor='amber';
    efficiencyStatus='More Data Needed';
  }else if(pp>50||oo>100){
    efficiencyColor='red';
    efficiencyStatus='Priority';
  }else if(pp>35||oo>80){
    efficiencyColor='amber';
    efficiencyStatus='Watch';
  }

  let techColor='green';
  let techStatus='Healthy Signal';
  if(!answered('agencyReliance')){
    techColor='amber';
    techStatus='More Data Needed';
  }else if(state.data.agencyReliance==='High'){
    techColor='red';
    techStatus='Priority';
  }else if(
    state.data.agencyReliance==='Medium' ||
    state.data.agencyReliance==='Unsure' ||
    !answered('techSpendBand')
  ){
    techColor='amber';
    techStatus='Watch';
  }

  let peopleColor='green';
  let peopleStatus='Healthy Signal';
  if(
    !answered('seniorLeadership') ||
    !answered('peopleManagers')
  ){
    peopleColor='amber';
    peopleStatus='More Data Needed';
  }else if(managerPct>35){
    peopleColor='red';
    peopleStatus='Priority';
  }else if(managerPct>25||leaderPct>20){
    peopleColor='amber';
    peopleStatus='Watch';
  }

  const findings=[];

  if(finColor==='red'){
    findings.push({title:'Financial Performance',copy:'Financial performance or cost structure is showing a material pressure signal that warrants immediate validation.'});
  }else if(finColor==='amber'){
    findings.push({title:'Financial Performance',copy:'Financial performance is mixed or incomplete, with at least one area that should be validated before stronger conclusions are drawn.'});
  }else{
    findings.push({title:'Financial Performance',copy:'The supplied financial profile shows a generally healthy directional signal across profitability, growth and cost structure.'});
  }

  if(efficiencyColor==='red'){
    findings.push({title:'Operating Efficiency',copy:'Operating costs or payroll appear heavy relative to revenue and should be reviewed for structural efficiency.'});
  }else if(efficiencyColor==='amber'){
    findings.push({title:'Operating Efficiency',copy:'Operating efficiency is a watch area based on payroll and operating-expense intensity.'});
  }else{
    findings.push({title:'Operating Efficiency',copy:'Payroll and operating expenses are directionally aligned with the current revenue profile.'});
  }

  if(techColor==='red'){
    findings.push({title:'Technology & Partners',copy:'External-partner reliance is high enough to warrant a closer review of ownership, cost and duplicated capability.'});
  }else if(peopleColor==='red'){
    findings.push({title:'People & Structure',copy:'Management density is elevated relative to reported employee count and may indicate organizational layering.'});
  }else if(inventoryColor==='red'){
    findings.push({title:'Inventory Exposure',copy:'Inventory exposure is elevated relative to annual revenue and may be tying up working capital.'});
  }else if(inventoryColor==='amber'&&ir!==null){
    findings.push({title:'Inventory Exposure',copy:'Inventory is a watch area relative to annual revenue and should be reviewed alongside turns, aging and markdown risk.'});
  }else{
    findings.push({title:'Operating Structure',copy:'No additional critical structural signal is evident from the self-service inputs, though deeper operating evidence may change the view.'});
  }

  const recs=[];

  if(finColor==='red'){
    recs.push([
      'Validate financial pressure points',
      'Reconcile actual EBITDA, gross margin, payroll and operating expenses against the selected ranges, then isolate the largest drivers of profitability pressure.'
    ]);
  }else if(finColor==='amber'){
    recs.push([
      'Validate financial performance',
      'Use actual financial statements to confirm the directional ranges and determine whether margin, growth or cost intensity requires intervention.'
    ]);
  }

  if(efficiencyColor==='red'||efficiencyColor==='amber'){
    recs.push([
      'Review operating efficiency',
      'Assess payroll, operating expenses, headcount and management structure together to identify cost, capacity or organizational-design opportunities.'
    ]);
  }

  if(techColor==='red'||techColor==='amber'){
    recs.push([
      'Review technology and partner reliance',
      'Inventory major technology platforms, agencies and consultants by cost, ownership, usage and capability to identify gaps, overlap or avoidable dependency.'
    ]);
  }

  if(inventoryColor==='red'||(inventoryColor==='amber'&&ir!==null)){
    recs.push([
      'Improve inventory productivity',
      'Review inventory turns, aging, markdown exposure and channel allocation to determine whether working capital can be released.'
    ]);
  }

  if(peopleColor==='red'||peopleColor==='amber'){
    recs.push([
      'Validate organizational structure',
      'Review spans of control, decision rights and leadership layers to confirm the organization is appropriately designed for its current scale.'
    ]);
  }

  if(recs.length===0){
    recs.push([
      'Move from directional to validated',
      'The self-service profile is well populated and does not show an immediate major pressure signal. Validate the findings against actual operating data before making material decisions.'
    ]);
  }

  const topRecs=recs.slice(0,4);

  const boostableOptional=[
    'website',
    'skuCountBand',
    'seniorLeadership',
    'peopleManagers',
    'workArrangement',
    'inventoryBand',
    'techSpendBand',
    'marketingSpendBand',
    'returnBand'
  ];

  const miss=
    boostableOptional
      .filter(
        k=>
          applicable().includes(k) &&
          !answered(k)
      )
      .sort(
        (a,b)=>
          (weights[b]||1)-
          (weights[a]||1)
      )
      .slice(0,3);

  return `
    <section class="resultsReport">

      <div class="sectionHead resultsIntro">

        <div class="kicker accent">
          Assessment Results
        </div>

        <h2>
          Business Health Report
        </h2>

        <p>
          This report is directional and based on the information supplied. Financial inputs use range midpoints. Benchmark-dependent conclusions remain provisional until the appropriate peer dataset and deeper operating information are available.
        </p>

      </div>

      <div class="resultActionBar">

        <p>
          Return to earlier sections to edit your answers or print/save this report for review.
        </p>

        <div class="resultActionButtons">

          <button
            type="button"
            class="btn secondary"
            id="reviewInputs"
          >
            Edit Your Answers
          </button>

          <button
            type="button"
            class="btn accentBtn"
            id="printSummary"
          >
            Save / Print Report
          </button>

        </div>

      </div>

      <div class="summaryGrid resultsSummary">

        <div class="summaryCard ${completionColor}">

          <div class="kicker">
            Completion
          </div>

          <div class="summaryValue ${completionColor}">
            ${completionPct}%
          </div>

          <p>
            ${cs.answered} of ${cs.total} applicable inputs completed.
          </p>

        </div>

        <div class="summaryCard ${confidenceColor}">

          <div class="kicker">
            Assessment Confidence
          </div>

          <div class="summaryValue ${confidenceColor}">
            ${confidenceLabel}
          </div>

          <p>
            Reflects information coverage, consistency and evidence availability. It is not a probability that the company is healthy.
          </p>

        </div>

      </div>
      <div class="reportSection keyFindings">

        <h3>
          Key Findings
        </h3>

        <div class="findingGrid">
          ${findings.map(finding=>`
            <article class="findingCard">
              <div class="findingTitle">${finding.title}</div>
              <p>${finding.copy}</p>
            </article>
          `).join('')}
        </div>

      </div>

      <div class="reportSection metricsSection">

        <h3>
          Operating Metrics
        </h3>

        <div class="metricGrid">

          ${metric(
            'Revenue / Employee',
            rev?'~'+moneyFmt.format(rpe):'—',
            rpeColor,
            rpeStatus,
            'A useful productivity measure, but it should not be judged without an appropriate peer group and business-model context.'
          )}

          ${metric(
            'Payroll / Revenue',
            pp===null?'—':'~'+pp.toFixed(0)+'%',
            payrollColor,
            payrollStatus,
            'Shows how much midpoint revenue is represented by employee compensation.'
          )}

          ${metric(
            'OpEx / Revenue',
            oo===null?'—':'~'+oo.toFixed(0)+'%',
            opexColor,
            opexStatus,
            'Shows the weight of operating expenses relative to midpoint revenue.'
          )}

          ${metric(
            'Inventory / Revenue',
            ir===null?'—':'~'+ir.toFixed(0)+'%',
            inventoryColor,
            inventoryStatus,
            'Provides a directional view of inventory exposure relative to annual revenue.'
          )}

        </div>

      </div>

      <div class="reportSection">

        <h3>
          RDigital Operator Health Review
        </h3>

        <p class="reportIntroCopy">
          Each area reflects the health signal supported by the information provided — not simply whether evidence exists.
        </p>

        <div class="lensGrid">

          ${lensCard(
            'Financial Visibility',
            finStatus,
            finColor,
            `Reported EBITDA is ${
              ebitda===null?'not available':
              ebitda<0?'negative':
              ebitda===0?'approximately break-even':
              'positive'
            }${
              growth!==null?`, revenue growth is approximately ${growth}%`: ''
            }${
              grossMargin!==null?`, and midpoint gross margin is approximately ${grossMargin}%`: ''
            }. Payroll is ${
              pp===null?'not available':`approximately ${pp.toFixed(0)}% of midpoint revenue`
            } and operating expenses are ${
              oo===null?'not available':`approximately ${oo.toFixed(0)}% of midpoint revenue`
            }.`,
            finColor==='red'
              ?'Validate the financial ranges against actual statements and isolate the largest drivers of profitability pressure.'
              :finColor==='amber'
              ?'Confirm the directional ranges with actual financials and investigate the watch areas before drawing stronger conclusions.'
              :'Maintain consistent reporting across revenue, margin, payroll, operating expenses, inventory and EBITDA.'
          )}

          ${lensCard(
            'Ownership & Accountability',
            ownershipStatus,
            ownershipColor,
            `The company reports ${leaders} senior leader${leaders===1?'':'s'} and ${managers} people manager${managers===1?'':'s'} across ${emp} employees. ${
              managerPct!==null?`People managers represent approximately ${managerPct.toFixed(0)}% of employees.`:''
            } These structural measures provide a directional signal, but accountability quality still requires confirmation of decision rights and ownership.`,
            ownershipColor==='red'
              ?'Review management layers, spans of control and decision rights for potential organizational density.'
              :ownershipColor==='amber'
              ?'Confirm leadership and manager structure, then map critical outcomes to accountable owners.'
              :'Validate that critical outcomes have clear owners with the authority and resources required to deliver them.'
          )}

          ${lensCard(
            'Operating Efficiency',
            efficiencyStatus,
            efficiencyColor,
            `The company reports ${emp} employees and approximately ${moneyFmt.format(rpe)} in midpoint revenue per employee. Payroll represents ${
              pp===null?'an unavailable share':`approximately ${pp.toFixed(0)}%`
            } of midpoint revenue and operating expenses represent ${
              oo===null?'an unavailable share':`approximately ${oo.toFixed(0)}%`
            }. Revenue per employee remains benchmark-dependent.`,
            efficiencyColor==='red'
              ?'Review cost structure, headcount and operating model together to identify the largest efficiency opportunities.'
              :efficiencyColor==='amber'
              ?'Validate payroll and operating-expense intensity against actuals and the company’s operating model.'
              :'Use peer benchmarking to determine whether current workforce productivity is competitive for the business model.'
          )}

          ${lensCard(
            'Technology & Partners',
            techStatus,
            techColor,
            `Agency / Consultant Reliance is ${
              answered('agencyReliance')?state.data.agencyReliance:'not provided'
            }${
              techPct!==null?` and annual technology spend represents approximately ${techPct.toFixed(1)}% of midpoint revenue`: ''
            }. The current assessment does not independently determine whether the technology stack itself is efficient.`,
            techColor==='red'
              ?'Perform a partner and technology audit focused on cost, ownership, duplicated capability and dependency.'
              :techColor==='amber'
              ?'Inventory major platforms and external partners to establish cost, ownership, usage and overlap.'
              :'Maintain clear internal ownership of platforms and partners and periodically review cost and capability overlap.'
          )}

          ${lensCard(
            'People & Culture',
            peopleStatus,
            peopleColor,
            `The company reports ${emp} employees, ${leaders} senior leader${leaders===1?'':'s'} and ${managers} people manager${managers===1?'':'s'}${
              answered('workArrangement')?` with a primary work arrangement of ${state.data.workArrangement}`:''
            }${
              answered('employeeRegions')?` across ${state.data.employeeRegions.length} employee region${state.data.employeeRegions.length===1?'':'s'}`:''
            }. These inputs assess structural context; culture quality requires deeper employee and leadership evidence.`,
            peopleColor==='red'
              ?'Review spans of control, leadership layers and organizational design, then supplement with targeted leadership and employee input.'
              :peopleColor==='amber'
              ?'Complete the organizational picture and validate whether management density matches the company’s scale and complexity.'
              :'Supplement the structural view with targeted leadership and employee evidence before making conclusions about culture.'
          )}

        </div>

      </div>


      <div class="rdigitalCta">

        <div class="rdigitalCtaMain">

          <h3>
            How RDigital Can Help
          </h3>

          <p>
            Business problems rarely come from one isolated issue. They build through increasing complexity, unclear ownership, weak accountability, fragmented decision-making, and gaps across people, technology, operations, and financial visibility. RDigital helps leadership teams identify where those issues are creating friction, simplify what has become unnecessarily complex, strengthen accountability, and turn the findings into clear priorities that can actually be executed.
          </p>

          <div class="rdigitalCtaActions">

            <a
              class="btn rdigitalPillButton"
              href="https://rdigital.ai/pages/services"
              target="_blank"
              rel="noopener"
            >
              View Our Services
            </a>

            <a
              class="btn rdigitalPillButton"
              href="https://rdigital.ai/pages/contact"
              target="_blank"
              rel="noopener"
            >
              Contact Us
            </a>

          </div>

        </div>

        <div class="rdigitalTestimonial">

          <blockquote>
            “Ben played a key role in the Champion migration and launch, combining strong technical expertise with a clear understanding of business needs. He orchestrated the go-live across teams and time zones, ensuring every task and owner was aligned for a smooth execution.”
          </blockquote>

          <div class="testimonialAuthor">
            <strong>Gabriele Barbati</strong>
            <span>Digital Director (Orbico)</span>
          </div>

          <a
            class="testimonialLink"
            href="https://rdigital.ai/pages/testimonials"
            target="_blank"
            rel="noopener"
          >
            View Testimonials →
          </a>

        </div>

      </div>

      ${
        miss.length
          ?`
            <div class="booster" id="booster">

              <div class="kicker" style="color:#58d6c1">
                Optional Depth
              </div>

              <h3>
                ${miss.length} high-value input${miss.length>1?'s':''} can still improve the assessment
              </h3>

              <p>
                These are the highest-weight unanswered optional inputs for this company profile.
              </p>

              <div class="boosterGrid">

                ${
                  miss.map(
                    k=>{

                      if(k==='seniorLeadership'||k==='peopleManagers'){
                        return `
                          <label>
                            ${optionalLabels[k]}
                            <input data-boost="${k}" type="text" inputmode="numeric">
                          </label>
                        `;
                      }

                      if(k==='website'){
                        return `
                          <label>
                            ${optionalLabels[k]}
                            <input data-boost="${k}" type="text">
                          </label>
                        `;
                      }

                      if(k==='workArrangement'){
                        return `
                          <label>
                            ${optionalLabels[k]}
                            <select data-boost="${k}">
                              <option value="">Select...</option>
                              <option value="In Office">In Office</option>
                              <option value="Hybrid">Hybrid</option>
                              <option value="Remote">Remote</option>
                              <option value="Mixed / Varies">Mixed / Varies</option>
                            </select>
                          </label>
                        `;
                      }

                      const list=
                        k==='returnBand'
                          ?returnBands
                          :moneyBands;

                      return `
                        <label>
                          ${optionalLabels[k]}
                          <select data-boost="${k}">
                            <option value="">Select...</option>
                            ${list.map(o=>`<option value="${o[0]}">${o[1]}</option>`).join('')}
                          </select>
                        </label>
                      `;

                    }
                  ).join('')
                }

              </div>

              <div class="navGroup" style="margin-top:18px">

                <button type="button" class="btn secondary" id="applyBoost">
                  Add These Answers
                </button>

                <button type="button" class="btn primary" id="finishNow">
                  Finish With Current Assessment
                </button>

              </div>

            </div>
          `
          :''
      }

    </section>
  `;

}

const screens=[

  overview,

  category,

  positioning,

  model,

  people,

  economics,

  results

];

function showReview(c){

  const b=
    $('#review');

  if(
    !b
  ){
    return;
  }

  b.classList.add(
    'show'
  );

  if(
    c.errors.length
  ){

    b.innerHTML=`
      <div
        class="kicker"
        style="color:#58d6c1"
      >
        Correction Required
      </div>

      <h3>
        Some values need to be fixed before continuing.
      </h3>

      ${
        c.errors.map(
          x=>`
            <p>
              • ${x}
            </p>
          `
        ).join('')
      }
    `;

    return;

  }

  b.innerHTML=`
    <div
      class="kicker"
      style="color:#58d6c1"
    >
      Review Required
    </div>

    <h3>
      These values are possible, but unusual.
    </h3>

    ${
      c.warnings.map(
        x=>`
          <p>
            • ${x}
          </p>
        `
      ).join('')
    }

    <div
      class="navGroup"
      style="margin-top:16px"
    >

      <button
        type="button"
        class="btn secondary"
        id="confirmWarning"
      >
        I Reviewed These Values - Continue
      </button>

      <button
        type="button"
        class="btn primary"
        id="editWarning"
      >
        Review Entries
      </button>

    </div>
  `;

  const confirm=
    $('#confirmWarning');

  const edit=
    $('#editWarning');

  if(
    confirm
  ){

    confirm.onclick=
      ()=>{

        state.confirmed[
          state.step
        ]=true;

        goToStep(
          state.step+1
        );

      };

  }

  if(
    edit
  ){

    edit.onclick=
      ()=>
        b.classList.remove(
          'show'
        );

  }

}

function clearConfirm(){

  delete state.confirmed[
    state.step
  ];

}

function syncBusinessCategory(
  value
){

  state.data.businessCategory=
    value||'';

  const cv=
    root.querySelector(
      '.categoryValue'
    );

  if(
    cv
  ){

    cv.textContent=
      value||
      'Not selected';

  }

  const blocked=
    !value;

  [
    $('#next'),
    $('#introStart')
  ]
    .filter(Boolean)
    .forEach(
      nx=>{

        nx.classList.toggle(
          'introInactive',
          blocked
        );

        nx.setAttribute(
          'aria-disabled',
          blocked
            ?'true'
            :'false'
        );

      }
    );

}

function bind(){

  $$(
    '[data-id]'
  ).forEach(
    el=>{

      el.oninput=
        ()=>{

          state.data[
            el.dataset.id
          ]=
            el.value;

          clearConfirm();

          updateProgress();

          if(
            el.dataset.id===
            'businessCategory'
          ){

            syncBusinessCategory(
              el.value
            );

          }

        };

      el.onchange=
        ()=>{

          state.data[
            el.dataset.id
          ]=
            el.value;

          if(
            el.dataset.id==='companyStatus'
          ){

            clearConfirm();

            render();

            return;

          }

          clearConfirm();

          updateProgress();

          if(
            el.dataset.id===
            'businessCategory'
          ){

            syncBusinessCategory(
              el.value
            );

          }

        };

    }
  );

  $$(
    '[data-tier]'
  ).forEach(
    b=>{

      b.onclick=
        ()=>{

          state.data.marketTier=
            b.dataset.tier;

          clearConfirm();

          render();

        };

    }
  );

  $$(
    '[data-customer]'
  ).forEach(
    b=>{

      b.onclick=
        ()=>{

          const v=
            b.dataset.customer;

          state.data.customerFocus=
            state.data.customerFocus.includes(v)
              ?state.data.customerFocus.filter(
                x=>x!==v
              )
              :[
                ...state.data.customerFocus,
                v
              ];

          clearConfirm();

          render();

        };

    }
  );

  const sac=
    $('#selectAllCustomers');

  if(
    sac
  ){

    sac.onchange=
      ()=>{

        state.data.customerFocus=
          sac.checked
            ?[
              'Women',
              'Men',
              'Kids'
            ]
            :[];

        clearConfirm();

        render();

      };

  }

  $$(
    '[data-model]'
  ).forEach(
    b=>{

      b.onclick=
        ()=>{

          const v=
            b.dataset.model;

          state.data.models=
            state.data.models.includes(v)
              ?state.data.models.filter(
                x=>x!==v
              )
              :[
                ...state.data.models,
                v
              ];

          if(
            !state.data.models.includes(
              state.data.primaryModel
            )
          ){

            state.data.primaryModel='';

          }

          clearConfirm();

          render();

        };

    }
  );

  $$(
    '[data-region-group]'
  ).forEach(
    btn=>{

      btn.onclick=
        ()=>{

          const id=
            btn.dataset.regionGroup;

          const value=
            btn.dataset.regionValue;

          const current=
            Array.isArray(state.data[id])
              ?state.data[id]
              :[];

          if(
            value==='Global'
          ){

            const allSelected=
              businessRegions.every(
                region=>current.includes(region)
              );

            state.data[id]=
              allSelected
                ?[]
                :[...businessRegions];

          }else{

            state.data[id]=
              current.includes(value)
                ?current.filter(
                  region=>region!==value
                )
                :[
                  ...current,
                  value
                ];

          }

          clearConfirm();

          render();

        };

    }
  );

  const ab=
    $('#applyBoost');

  if(
    ab
  ){

    ab.onclick=
      ()=>{

        $$(
          '[data-boost]'
        ).forEach(
          el=>{

            if(
              String(
                el.value
              ).trim()
            ){

              state.data[
                el.dataset.boost
              ]=
                el.value;

            }

          }
        );

        render();

      };

  }

  const fn=
    $('#finishNow');

  if(
    fn
  ){

    fn.onclick=
      ()=>{

        const b=
          $('#booster');

        if(
          b
        ){
          b.remove();
        }

      };

  }

  const ri=
    $('#reviewInputs');

  if(
    ri
  ){

    ri.onclick=
      ()=>{

        goToStep(1);

      };

  }

  const ps=
    $('#printSummary');

  if(
    ps
  ){

    ps.onclick=
      ()=>window.print();

  }

  if(
    state.step===0
  ){

    const categorySelect=
      root.querySelector(
        '#businessCategorySelect'
      );

    const startButton=
      $('#introStart');

    const syncStart=
      ()=>{

        const value=
          categorySelect
            ?categorySelect.value
            :'';

        syncBusinessCategory(
          value
        );

      };

    if(
      categorySelect
    ){

      categorySelect.onchange=
        syncStart;

      categorySelect.oninput=
        syncStart;

    }

    if(
      startButton
    ){

      startButton.onclick=
        startAssessment;

    }

    syncStart();

  }

}

function startAssessment(){

  const liveCategory=
    root.querySelector(
      '#businessCategorySelect'
    ) ||
    root.querySelector(
      'select[data-id="businessCategory"]'
    );

  const selected=
    liveCategory
      ?liveCategory.value
      :'';

  if(
    !selected
  ){

    const err=
      $('#error');

    if(
      err
    ){

      err.textContent=
        'Select a business category to begin.';

    }

    return;

  }

  state.data.businessCategory=
    selected;

  state.step=1;

  render();

  window.scrollTo({
    top:0,
    behavior:'smooth'
  });

}

function render(
  nextStep=state.step
){

  const screen=
    $('#screen');

  if(
    !screen
  ){
    return false;
  }

  let markup='';

  try{

    markup=
      screens[
        nextStep
      ]();

  }catch(err){

    console.error(
      'RDigital Business Health Assessment render error:',
      err
    );

    const error=
      $('#error');

    if(
      error
    ){

      error.textContent=
        'We couldn\'t generate your assessment. Your answers have been preserved. Please review your entries and try again.';

    }

    return false;

  }

  state.step=
    nextStep;

  embed.classList.toggle(
    'introMode',
    state.step===0
  );

  screen.innerHTML=
    markup;

  const nav=
    $('#nav');

  if(
    nav
  ){

    nav.classList.toggle(
      'hidden',
      state.step===0
    );

  }

  const catLabel=
    root.querySelector(
      '.categoryValue'
    );

  if(
    catLabel
  ){

    catLabel.textContent=
      state.data.businessCategory||
      'Not selected';

  }

  const whyText=
    $('#whyText');

  if(
    whyText
  ){

    whyText.textContent=
      why[state.step]||
      '';

  }

  const whyPanel=
    $('#whyPanel');

  if(
    whyPanel
  ){

    whyPanel.classList.toggle(
      'hidden',
      state.step===0 ||
      state.step===6
    );

  }

  const review=
    $('#review');

  if(
    review
  ){

    review.classList.remove(
      'show'
    );

  }

  const error=
    $('#error');

  if(
    error
  ){

    error.textContent='';

  }

  const back=
    $('#back');

  if(
    back
  ){

    back.classList.toggle(
      'hidden',
      state.step===0
    );

  }

  const next=
    $('#next');

  if(
    next
  ){

    next.classList.toggle(
      'hidden',
      state.step===6
    );

    next.textContent=
      state.step===0
        ?'Start Assessment'
        :state.step===5
        ?'Generate Assessment'
        :'Continue';

    const introBlocked=
      state.step===0 &&
      !answered(
        'businessCategory'
      );

    next.classList.toggle(
      'introInactive',
      introBlocked
    );

    next.setAttribute(
      'aria-disabled',
      introBlocked
        ?'true'
        :'false'
    );

  }

  updateProgress();

  bind();

  return true;

}

function goToStep(
  nextStep
){

  const moved=
    render(
      nextStep
    );

  if(
    moved
  ){

    window.scrollTo({
      top:0,
      behavior:'smooth'
    });

  }

  return moved;

}

embed.addEventListener(
  'change',
  e=>{

    if(
      e.target &&
      e.target.matches(
        'select[data-id="businessCategory"]'
      )
    ){

      syncBusinessCategory(
        e.target.value
      );

    }

  }
);

embed.addEventListener(
  'input',
  e=>{

    if(
      e.target &&
      e.target.matches(
        'select[data-id="businessCategory"]'
      )
    ){

      syncBusinessCategory(
        e.target.value
      );

    }

  }
);

const nextButton=
  $('#next');

if(
  nextButton
){

  nextButton.onclick=
    ()=>{

      if(
        state.step===0
      ){

        startAssessment();

        return;

      }

      normalizeCounts();

      $$(
        '[data-id]'
      ).forEach(
        el=>{

          state.data[
            el.dataset.id
          ]=
            el.value;

        }
      );

      updateProgress();

      if(
        requiredMissing()
      ){

        const err=
          $('#error');

        if(
          err
        ){

          err.textContent=
            'Complete the required fields on this section before continuing.';

        }

        return;

      }

      const c=
        checks();

      if(
        c.errors.length
      ){

        showReview(c);

        return;

      }

      if(
        c.warnings.length &&
        !state.confirmed[
          state.step
        ]
      ){

        showReview(c);

        return;

      }

      goToStep(
        state.step+1
      );

    };

}

const backButton=
  $('#back');

if(
  backButton
){

  backButton.onclick=
    ()=>{

      if(
        state.step>0
      ){

        goToStep(
          state.step-1
        );

      }

    };

}

render();

})();